import PropTypes from "prop-types";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { css, useTheme } from "@emotion/react";
import { rem } from "@util/convertUnits";
import { ButtonPill } from "@/base";
import useOutsideClick from "@/helpers/useOutsideClick";
import NavImageTile from "@/core/navigation/NavImageTile";
import useOutsideMouse from "@/helpers/useOutsideMouse";

const NavBarWide = ({ navData }) => {
  const theme = useTheme();
  const [currentOpenGroup, setCurrentOpenGroup] = useState("");
  const menuRef = useRef();

  useEffect(() => {
    const header = document.querySelector(".header");
    const outFunc = () => {
      setCurrentOpenGroup(null);
    };
    header.addEventListener("mouseleave", outFunc);

    return () => {
      header.removeEventListener("mouseleave", outFunc);
    };
  }, []);

  const styleNavGroup = css`
    margin-bottom: 0;

      .pill-nav {
        margin-top: 5px;
      }
  `;

  const ddStyles = css`
    justify-content: center;
    min-height: ${rem(310)};
    position: absolute;
    left: 0;
    display: flex;
    width: 100%;
    padding-top: 2.2rem;
  `;

  const ddNavStyles = css`
    display: flex; 
    width: 100%;
    background-color: #ffffff;
    z-index: 11;

    > ul {
      padding: 0;
      list-style: none;
    }

    li {
      margin-bottom: 0;

      a {
        padding-left: 0;
        padding-right: 0;
        display: block;
        padding: 0.8rem 2.1rem;
        text-decoration: none;
        color: ${theme.brandColors.based[theme.variant]};
      }
    }
  `;

  const navCol = css`
    padding: 0;
    list-style: none;

    a {
      &:hover {
        text-decoration: underline;
      }
    }

    .is-4col & {
      font-weight: 700;

      > ul {
        margin-top: 0.8rem;
        font-weight: 400;

        a {
          color: ${theme.brandColors.base[theme.variant]};
        }
      }
    }

    .is-2col & {
      a {
        color: ${theme.brandColors.base[theme.variant]};
      }
    }

    > ul {
      padding: 0;
      list-style: none;
    }
  `;

  useOutsideClick(menuRef, () => {
    setCurrentOpenGroup("");
  });

  useOutsideMouse(menuRef, () => {
    setCurrentOpenGroup("");
  });

  const handleCloseMenu = () => setCurrentOpenGroup("");

  const renderMultiColMenu = (group) => {
    // Ensure `group.children` is an array before using map
    const children = group.children || [];

    return (
      <div css={ddStyles}>
        <div className="is-4col py-3.5" css={ddNavStyles}>
          <ul className="row mx-0">
            {children.map((c) => (
              <li
                className="px-2.5"
                css={navCol}
                key={`${c.name}${c.url}`}
              >
                <Link to={c.url} onClick={handleCloseMenu}>
                  {c.name}
                </Link>
                <ul>
                  {(c.children || []).map((p) => (
                    <li key={`NavBar${p.name}${p.url}`}>
                      <Link to={p.url} onClick={handleCloseMenu}>
                        {p.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
          <div className="size-2of6 pr-4">
              {(group.tiles || []).map((tile) => {
                return (
                  <NavImageTile
                    key={tile}
                    slug={tile}
                    size={group.tiles.length}
                    onClick={handleCloseMenu}
                  />
                );
              })}
            </div>
        </div>
      </div>
    );
  };

  const renderStandardMenu = (group) => {
    // Ensure `group.children` is an array before using map
    const children = group.children || [];

    return (
      <div css={ddStyles}>
        <div className="is-2col row mx-0 py-3.5 pl-2.5" css={ddNavStyles}>
          <ul className="size-1of4 size-lg-5of12 px-2.5" css={navCol}>
            {children.map((c) => (
              <li key={`${c.name}${c.url}`}>
                <Link to={c.url} onClick={handleCloseMenu}>
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
          <div
            className="size-3of4 size-lg-7of12 d-flex flex-row justify-content-end pr-4"
            css={{}}
          >
            {(group.tiles || []).map((tile) => {
              return (
                <NavImageTile
                  key={tile}
                  slug={tile}
                  size={group.tiles.length}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const listCss = css`
    flex-wrap: nowrap;
    justify-content: center;
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  `;

  return (
    <span css={listCss} ref={menuRef}>
      {navData.map((navGroup) => (
        <li
          key={navGroup.name}
          css={styleNavGroup}
          onMouseOver={() => setCurrentOpenGroup(navGroup?.name)}
          // onMouseOut={()=>setCurrentOpenGroup(null)}
          onFocus={() => setCurrentOpenGroup(navGroup?.name)}
          // onBlur={()=>setCurrentOpenGroup(null)}
          className={currentOpenGroup === navGroup.name && "active"}
        >
          <ButtonPill
            buttonTheme={`nav`}
            active={currentOpenGroup === navGroup.name}
            // onClick={(e) => handleToggle(e,navGroup.name)}
            // onKeyDown={buttonClick}
            role="button"
            tabIndex="0"
          >
            {navGroup.name}
          </ButtonPill>
          {navGroup.isMultiCol && currentOpenGroup === navGroup.name &&
            renderMultiColMenu(navGroup)}
          {!navGroup.isMultiCol && currentOpenGroup === navGroup.name &&
            renderStandardMenu(navGroup)}
        </li>
      ))}
    </span>
  );
};

NavBarWide.propTypes = {
  navData: PropTypes.array,
};

export default NavBarWide;